import { navigationService } from 'app/services/navigation-service';
import { resetOrderStateToInitialActionCreator } from 'app/pages/order/redux/action-creators/reset-order-state-to-initial-action-creator';
import { resetAuthStateToInitialActionCreator } from 'app/pages/auth/redux/action-creators/reset-auth-state-to-initial-action-creator';
import { AppDispatch } from 'app/redux/types/types';
import { AuthService } from 'app/pages/auth/service/auth-service';

export const logoutActionCreator = () => (dispatch: AppDispatch) => {
    AuthService.logout()
        // eslint-disable-next-line no-console
        .catch(() => console.warn('Failed to logout'))
        .finally(() => {
            dispatch(resetOrderStateToInitialActionCreator());
            dispatch(resetAuthStateToInitialActionCreator());
            navigationService.goToMainPage();
        });
};
